import { VueModule } from '@Foundation/utilities';
import GenericStickyHeader from './code/Scripts/components/generic-sticky-header';

export default VueModule({
  components: {
    GenericStickyHeader,
  },
});
